import commonCss from "PFApp/activities/show/activity_page/activity_page.module.scss";
import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useActivityMatches } from "PFApp/activities/show/hooks/use_activity_matches";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useMatchesActions, useMatchesStore } from "PFApp/activities/show/store/matches";
import { MatchCard } from "PFApp/components/activity_match_card";
import { LoadingDots } from "PFComponents/loading_dots";
import { SimplePagination } from "PFComponents/pagination/simple_pagination";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";

import { MatchTableEntry } from "../../../activity_tabs.utils";
import css from "./matches_view.module.scss";

type MatchesCardsViewProps = {
  matchesEntries: MatchTableEntry[];
  isLoading: boolean;
};

export const MatchesCardsView = ({ matchesEntries, isLoading }: MatchesCardsViewProps) => {
  const { isFillDisabled } = useActivityShowContext();
  const activity = useCurrentActivity();
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);

  const { matchesMeta } = useActivityMatches();
  const matchesParams = useMatchesStore((state) => state.matchesParams);
  const { updateMatchesParams } = useMatchesActions();

  return (
    <div className={commonCss.pageCardEntriesList} data-qa-id="ActivityMatchesTabCardsContainer">
      {isLoading && <LoadingDots circlesEnabled circleSize="xs" className={commonCss.loading} />}

      {matchesEntries.map(({ match }) => (
        <MatchCard
          role={activity}
          key={match.id}
          match={match}
          isUnbiasedMode={isUnbiasedMode}
          isFillDisabled={isFillDisabled}
          areButtonsDisabled={isLoading}
          isOnMatchesTab
          classes={{
            card: css.card
          }}
        />
      ))}
      <SimplePagination
        currentPage={matchesParams.page}
        handleClick={(num) => updateMatchesParams({ page: num })}
        totalPages={matchesMeta?.totalPages || 0}
      />
    </div>
  );
};
